export * from './forgot-password.component';
export * from './forgot-password-request';


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/auth/forgot-password/index.ts